export const name = {
  dangerChar: "name cannot contain dangerous characters"
};

export const email = {
  firstNotSpecial: "invalid email address",
  isNotEmpty: "please enter an email address",
  emailNotTaken: "email is already registered",
  typeMismatch: "invalid email address",
  noUserAtEmail: "email not registered",
  userNotFound: "user not registered"
};
export const password = {
  isNotEmail: "password cannot be your email -",
  passwordLength: "password must be at least 8 characters -",
  hasLowerCase: "password must contain at least one lowercase character -",
  hasUpperCase: "password must contain at least one uppercase character -",
  hasNumber: "password must contain a number",
  incorrectPassword: "incorrect password"
};
export const passwordConfirm = {
  passwordsMatch: "passwords must match"
};



// WEBPACK FOOTER //
// ./src/util/errorMessages.js